<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">娱乐会员</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 商家选择  开始 -->
    <div class="page_top"></div>
    <div class="page_taocan video_shop">
      <div class="page_taocan_list video_shopList">
        <div v-for="(item,index) in storeList" @click="todetail(index)" :class="item.storeselect ? 'page_taocan_box1':'page_taocan_box'"
          class="video_shopbox">
          <img class="video_shopboximg" :src="item.thumb" />
          <!-- <div class="shopping_des">{{item.name}}</div> -->
          <img v-if="item.storeselect" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
        </div>
      </div>
    </div>
    <div class="videonone"></div>
    <!-- 商家选择  结束 -->
    <!-- 套餐类型  开始 -->
    <div v-for="(item,index) in productItem">
      <!-- 套餐详情  开始 -->
      <div class="page_taocan video_taocan">
        <div class="page_taocan_name">{{item.name}}</div>
        <div class="page_taocan_list">
          <div :class="item1.id===id?'page_taocan_box1':'page_taocan_box'" class="video_shopbox" v-for="(item1,index1) in item.productItem"
            @click="selectnum(index1,index)">
            <div class="page_taocan_num">{{item1.name}}</div>
            <div class="page_taocan_num">售{{item1.price}}元</div>
            <img v-if="item1.id===id" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
          </div>
        </div>
      </div>
      <!-- 套餐详情  结束 -->
    </div>
    <!-- 套餐类型  结束 -->
    <!-- 填写账号  开始 -->
    <!--    <div class="page_taocan video_zhangaho" v-if="isphone">
      <div class="page_taocan_name">填写账号</div>
      <input v-model="phonenum" placeholder="请输入手机号码充值" class="page_pnuminput" />
    </div>
    <div class="page_taocan video_zhangaho" v-else>
      <div class="page_taocan_name">填写账号</div>
      <input v-model="qqnum" :placeholder="storeDeatil.api_tab==='qq_video'||storeDeatil.api_tab==='qq_music' ? '请输入QQ账号充值' : '请输入酷狗账号充值'" class="page_pnuminput" />
    </div> -->

    <div class="page_taocan video_zhangaho" v-if="isphone">
      <div class="page_taocan_name">填写账号</div>
      <input v-model="phonenum" placeholder="请输入手机号码充值" class="page_pnuminput" />
    </div>
    <div class="page_taocan video_zhangaho" v-else-if="isqq">
      <div class="page_taocan_name">填写账号</div>
      <input v-model="qqnum" placeholder="请输入qq账号充值" class="page_pnuminput" />
      <!-- <input v-model="qqnum" :placeholder="storeDeatil.api_tab==='qq_video'||storeDeatil.api_tab==='qq_music' ? '请输入QQ账号充值' : '请输入酷狗账号充值'" class="page_pnuminput" /> -->
    </div>
    <div class="page_taocan video_zhangaho" v-else>
      <div class="page_taocan_name">填写账号</div>
      <input v-model="kugounum" placeholder="请输入酷狗账号充值" class="page_pnuminput" />
    </div>
    <!-- 填写账号  结束 -->
    <div class="pagetype_taocan">
      <div class="pagepaytype_text">选择支付方式</div>
      <!-- <div class="page_shangpin_box" @click="weixinPay()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">微信支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_shoujia">{{ price ? price+'元' : '' }}</div>
          <img :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
        </div>
      </div> -->
      <div class="page_shangpin_box" @click="yuePay()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">积分支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_keyong">可用积分</div>
          <div class="page_shangpin_shoujia">{{amount}}</div>
          <img :src="isAmountPay? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="page_checklogo" />
        </div>
      </div>
      <div class="page_shangpin_box" @click="showPopup()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/cardPay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">卡券支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_keyong">{{couponList.length}}张</div>
          <div class="page_shangpin_shoujia" v-if="selectedcardID">已选</div>
          <div class="page_shangpin_shoujia" v-else>未选</div>
          <img :src="selectedcardID ? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="page_checklogo" />
        </div>
      </div>
    </div>
    <!-- 支付 开始 -->
    <div class="page_button video_zhifu" @click="toRecharge()">
      <div class="page_zhifu">立即充值</div>
    </div>
    <!-- 支付 结束 -->

    <!-- 注意事项  开始 -->
    <div class="page_mesg" v-if="storeDeatil.detail">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">注意事项</div>
      </div>
      <div class="page_mesgtip">{{storeDeatil.detail}}</div>
    </div>
    <!-- 注意事项  结束 -->
    <!-- 卡券弹出层 开始 -->
    <van-popup v-model="showCardList" position="bottom" :style="{ height: '50%' }">
      <div class="cardlist_popup_top">
        <div class="cardlist_popup_topcancel" @click="cancel()">取消</div>
        <div class="cardlist_popup_topcenter">选择卡券</div>
        <div class="cardlist_popup_topconfirm" @click="confirm()">确定</div>
      </div>
      <div class="cardlist_popup_list">
        <!-- <div class="cardlist_popup_box" v-for="(item,index) in couponList">
          <div class="cardlist_popup_boxtop">卡券名称：{{item.name}}</div>
          <div class="cardlist_popup_boxbot">到期日期：2020-09-23</div>
          <img class="cardlist_popup_img" src="/static/bukeyong.png" />
        </div> -->
        <div class="cardlist_popup_box1" v-for="(item,index) in couponList" @click="checkCard(index)">
          <div>
            <div class="cardlist_popup_boxtop">卡券名称：{{item.related.name}}</div>
            <div class="cardlist_popup_boxbot">到期日期：{{item.overdue_at}}</div>
          </div>
          <img class="cardlist-pop-check" :src="item.checked ? '/static/newicon/checkedicon.png':'/static/newicon/checkicon.png'" />

          <!-- <img class="cardlist_popup_img" src="/static/newicon/che.png" /> -->
        </div>
      </div>
    </van-popup>
    <!-- 卡券弹出层 结束 -->
  </div>
</template>

<script>
  import axios from 'axios'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        amount: "", //用户所有积分数
        listDetail: {}, //上个页面传来的会员详情
        storeDeatil: {}, //接口获取商品详情
        productItem: [], //商品套餐分类列表
        phonenum: "", //手机充值账号
        price: "", //应付金额
        isphone: false, //是否有手机充值
        isqq: false, //是否是qq账号充值
        qqnum: "", //qq充值账号
        kugounum: "", //酷狗账号
        buttonClicked: false, // 防止支付重复点击,默认为false
        packageValue: 0, //套餐标识
        proindex: "", //套餐类型标识
        source_desc: "", //充值说明
        id: "", //套餐详情id
        storeList: [], //接口获取商品列表
        productDetailid: "",
        isWeixinPay: false, //是否为微信支付
        isAmountPay: false, //是否为余额支付
        showCardList: false, //是否显示卡券列表弹框: false,
        couponList: [], //卡券列表
        selectedcardID: "", //所选卡券id
      }
    },
    created() {
      if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
      this.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //改变商家
      todetail(e) {
        let that = this
        console.log("改变", e)
        let storeList = that.storeList

        storeList.map((item, index) => item.storeselect = index === Number(e))
        console.log("选择", storeList[e].storeselect)
        that.productDetailid = that.storeList[Number(e)].id
        this.request("getProductDetail", {
          id: this.productDetailid
        })
      },
      //关闭卡券弹出层
      guanbi() {
        this.showCardList = false
      },
      cancel() {
        this.showCardList = false
      },
      confirm() {
        this.showCardList = false
      },
      //显示卡券弹出层
      showPopup() {
        if (this.couponList.length == 0) {
          this.$toast({
            message: '暂无可用卡券',
          })
        } else {
          this.showCardList = true
        }
      },
      //改变选择的套餐
      selectnum(e, proindex) {
        let that = this
        //获取套餐详情id
        that.id = that.productItem[Number(proindex)].productItem[Number(e)].id
        //that.productItem[Number(proindex)].productItem.map((item1, index1) => item1.packageChecked = index1===Number(e))
        //获取套餐详情价格
        that.price = that.productItem[Number(proindex)].productItem[Number(e)].price
        //获取套餐详情说明
        that.source_desc = that.productItem[Number(proindex)].productItem[Number(e)].source_desc
        //获取套餐类型标识
        that.proindex = Number(proindex)
        //获取套餐详情标识
        that.packageValue = Number(e)
        that.request("getCouponList")
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //选择卡券支付
      checkCard(e) {
        // var couponlist = this.couponlist
        // couponlist.map((item, index) => item.checked = index === e)
        let that = this
        let couponlist = this.couponList
        couponlist.map(function(item, i) {
          if (i == Number(e)) {
            item.checked = true
            that.selectedcardID = item.id;
            // that.showCardList = false
          } else {
            item.checked = false;
            // that.showCardList = false
          }
        })
        that.couponList = couponlist;
        that.isAmountPay = false;
        that.isWeixinPay = false
        // that.guanbi();
      },
      //微信支付
      weixinPay() {
        this.isWeixinPay = true
      },
      //余额支付
      // yuePay() {
      //   this.isWeixinPay = false
      // },
      //余额支付
      yuePay() {
        if (!this.isAmountPay) {
          this.selectedcardID = "";
          this.couponList.map(item => (item.checked = false));
          this.isAmountPay = true;
          this.isWeixinPay = false
        }
      },
      //支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        // 手机号码格式错误时顶部显示错误提示2秒
        // if (this.isphone){
        //   if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
        //     this.$toast({
        //       message: '手机号格式错误'
        //     })
        //     return
        //   }
        // }
        // if (!that.qqnum) {
        //   this.$toast({
        //     message: '请输入账号'
        //   })
        //   return
        // }
        if (!(this.id)) {
          this.$toast({
            message: '请选择套餐',
          })
          return
        }

        // 手机号码格式错误时顶部显示错误提示2秒
        if (this.isphone) {
          if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
            this.$toast({
              message: '手机号格式错误'
            })
            return
          }
        } else if (that.isqq) {
          if (!that.qqnum) {
            this.$toast({
              message: '请输入qq账号'
            })
            return
          }
        } else {
          if (!that.kugounum) {
            this.$toast({
              message: '请输入酷狗账号'
            })
            return
          }
        }

        var product = that.storeDeatil
        // var productItem = that.productItem[that.proindex].productItem[that.packageValue]
        // console.log("productItem", productItem)

        order_param.amount = this.price
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_item_id = this.id
        order_param.recharge_number = that.phonenum || that.qqnum + ''
        console.log("that.amount > productItem.price", that.amount > this.price)
        // 判断用户是微信支付还是余额支付
        if (this.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否使用微信支付?',
            })
            .then(() => {
              // order_param.pay_type = 'balance'
              // that.request('YeunifiedOrder', order_param)
              order_param.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        } else if (this.isAmountPay) {
          if (parseFloat(that.amount) < parseFloat(that.price)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '是否用余额支付?',
              })
              .then(() => {
                order_param.pay_type = 'balance'
                that.request('YeunifiedOrder', order_param)
              })
              .catch(() => {
                return false;
              });
          }
        } else {
          Dialog.confirm({
              title: '提示',
              message: '是否用卡券支付?',
            })
            .then(() => {
              order_param.pay_type = 'coupon'
              order_param.coupon_id = that.selectedcardID
              console.log("order_param",order_param)
              that.request('YeunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        }

      },
      // 调用接口封装
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取个人信息余额
          case 'getUserInfo':
            //获取个人信息余额
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code === 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                console.log('amount1', amount1)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code === 0) {
                console.log("商品列表", res)
                this.storeList = res.data
                this.storeList.map(v => {
                  this.$set(v, 'storeselect', false)
                  return v
                })
                this.productDetailid = this.storeList[0].id
                this.storeList[0].storeselect = true
                this.request("getProductDetail", {
                  id: this.productDetailid
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            //获取商品详情
          case 'getProductDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code === 0) {
                console.log("商品详情", res)
                // if (res.data.api_tab === 'iq_video' || res.data.api_tab === 'yk_video' || res.data.api_tab ===
                //   'sh_video' || res.data.api_tab === 'cq_coupon') {
                //   that.isphone = true
                // }else{
                //   that.isphone = false
                // }
                if (res.data.api_tab === 'iq_video' || res.data.api_tab === 'yk_video' || res.data.api_tab ===
                  'sh_video' || res.data.api_tab === 'cq_coupon' || res.data.api_tab === 'mg_tv') {
                  that.isphone = true
                } else if (res.data.api_tab === 'qq_video' || res.data.api_tab === 'qq_music') {
                  that.isphone = false
                  that.isqq = true
                } else {
                  that.isphone = false
                  that.isqq = false
                }
                this.storeDeatil = res.data
                this.productItem = this.storeDeatil.productItem
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //卡券列表
          case "getCouponList":
            httper.post("coupon/package-list", requestData, res => {
              let list = [];
              if (res.data) {
                console.log("res.data", res.data)
                console.log("that.id", that.id)
                res.data.map(function(item, i) {
                  if (item.product_item_id == that.id && item.type == 2 && item.status != 2) {
                    list.push(item)
                  }
                })
              }
              console.log("list", list)
              that.couponList = list;
            });
            break;
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  .video_shop {
    height: 222px;
    /* top: 21px; */
    top: -185px;

  }

  .video_shopList {
    width: 100%;
    height: 100%;

  }

  .video_shopbox {
    margin: 5px 5px;
    display: flex;
    flex-direction: column;

  }

  .video_shopboximg {
    width: 100%;
    height: 100%;
  }


  .videonone {
    width: 100%;
    /*    height: 55px;
    margin-top: -160px; */
    height: 10px;
    margin-top: -195px;
  }

  .video_taocan {
    position: static;
    /* margin-top: 74px; */
    margin-top: 20px;
    height: auto;
  }

  .video_zhangaho {
    position: static;
    margin-top: 22px;

    height: auto;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    font-size: 13px;

    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
  }

  .video_zhifu {
    margin-top: 22px;
    margin-bottom: 20px;
  }
  /* 卡券弹出层 开始 */
  .cardlist_popup_top {
    width: 100%;
    height: 18%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EEEEEE;
  }

  .cardlist_popup_topcancel {
    font-size: 14px;
    color: #969799;
  }

  .cardlist_popup_topcenter {
    font-size: 16px;
  }

  .cardlist_popup_topconfirm {
    font-size: 14px;
    color: #576b95;
  }

  .cardlist_popup_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

  }

  .cardlist_popup_box {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #EEEEEE;
    border-radius: 8px;
  }

  .cardlist_popup_box1 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #029DFF;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cardlist_popup_boxtop {
    color: #363636;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cardlist_popup_boxbot {
    color: #BBBBBB;
    font-size: 14px;
  }
  .cardlist-pop-check{
    width: 14px;
    height: 14px;
  }

  .cardlist_popup_img {
    position: absolute;
    top: 0;
    right: 0;
    width: 69px;
    height: 23px;
  }

  /* 卡券弹出层 结束 */
</style>



// WEBPACK FOOTER //
// src/pages/video/videoDetail.vue